module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDE3IDE3Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjNUU2OTc3IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41Ij4KICAgICAgICA8cGF0aCBkPSJNMTQuNSAxMC40OTVWMTQuNUExLjUgMS41IDAgMCAxIDEzIDE2SDIuNUExLjUgMS41IDAgMCAxIDEgMTQuNVY0YTEuNSAxLjUgMCAwIDEgMS41LTEuNWg0LjAwNSIvPgogICAgICAgIDxwYXRoIGQ9Ik0xMyAxbDMgMy03LjUgNy41aC0zdi0zeiIvPgogICAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/edit.svg
// module id = RgRl
// module chunks = 1